import React from "react";
import { Character } from "./types";
import { StatCard } from "./StatCard";

interface BackstoryTabProps {
	character: Character;
	updateCharacter: (path: string, value: any) => void;
}

export const BackstoryTab: React.FC<BackstoryTabProps> = ({
	character,
	updateCharacter,
}) => (
	<div className="space-y-8">
		{/* Backstory */}
		<StatCard title="Character Backstory">
			<textarea
				value={character.backstory}
				onChange={(e) => updateCharacter("backstory", e.target.value)}
				className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors duration-200 resize-none"
				rows={12}
				placeholder="Tell your character's story - their history, background, and what brought them to adventuring..."
			/>
		</StatCard>

		{/* Allies & Organizations */}
		<StatCard title="Allies & Organizations">
			<textarea
				value={character.alliesOrganizations}
				onChange={(e) =>
					updateCharacter("alliesOrganizations", e.target.value)
				}
				className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors duration-200 resize-none"
				rows={8}
				placeholder="Important NPCs, organizations, factions, and contacts..."
			/>
		</StatCard>

		{/* Experience Points */}
		<StatCard title="Experience Points">
			<div className="text-center">
				<div className="bg-gradient-to-b from-indigo-100 to-indigo-200 rounded-2xl p-6 border-2 border-indigo-300 inline-block">
					<input
						type="number"
						value={character.experiencePoints}
						onChange={(e) =>
							updateCharacter(
								"experiencePoints",
								parseInt(e.target.value) || 0
							)
						}
						className="text-4xl font-black text-indigo-800 bg-transparent border-none outline-none text-center w-40"
						min="0"
					/>
					<div className="text-sm text-indigo-600 font-semibold mt-2">
						Experience Points
					</div>
				</div>
			</div>
		</StatCard>
	</div>
);
